import React from "react"
import styles from "./transactions.module.scss"
import {TransactionsList} from "./transactions-list"
import {SortOptions, TransactionsSettings} from "../../../services/api/transactions-api"
import {TransactionsWithCount} from "../../../domain/transactions-with-count"
import {FormTextInput} from "../../../components-shared/forms/form-text-input/form-text-input-view"
import {Transaction} from "../../../domain/transaction"
import {SelectedCategoryPill} from "../insight/selected-item-pill/selected-category-pill"

interface TransactionsViewProps {
  setCategoryId: (categoryId: number) => void
  scopeDisplay: string | null
  transactionsSettings: TransactionsSettings
  setTransactionsSettings: (transactionsSettings: TransactionsSettings) => void
  transactionsWithCount: TransactionsWithCount
  changeSort: (sort: SortOptions) => void
  showAll: () => void
  clickTransaction: (transaction: Transaction) => void
  showFilter: boolean
  impactFirst?: boolean
  resetCategoryScope?: ResetCategoryScope
}

export const TransactionsView: React.FC<TransactionsViewProps> = ({transactionsSettings, setTransactionsSettings, transactionsWithCount, changeSort, showAll, clickTransaction, showFilter, impactFirst, resetCategoryScope}) => {
  const allShown = transactionsWithCount.totalCount > transactionsWithCount.transactions.length
  const notShown = transactionsWithCount.totalCount - transactionsWithCount.transactions.length

  return <div className={styles.Transactions}>
    {resetCategoryScope && transactionsSettings.categoryId && <div><SelectedCategoryPill id={transactionsSettings.categoryId} onClick={() => resetCategoryScope?.resetCategoryScope()} /></div> }
    {/*{scopeDisplay !== null*/}
    {/*  ? <div>*/}
    {/*    Getoond: {scopeDisplay}*/}
    {/*    {resetCategoryScope && <>&nbsp;<Button color={"greenup-blue"} onClick={() => resetCategoryScope.resetCategoryScope()}>{resetCategoryScope.text}</Button></>}*/}
    {/*  </div>*/}
    {/*  : null}*/}
    {showFilter && <TransactionsFilter transactionsSettings={transactionsSettings} setTransactionsSettings={setTransactionsSettings}/>}
    <TransactionsList transactions={transactionsWithCount.transactions} sortOn={transactionsSettings.sortOn} changeSort={changeSort} clickTransaction={clickTransaction} impactFirst={impactFirst}/>
    {allShown && <div className={styles.ShowAll}><button onClick={() => showAll()} className={styles.ShowAll}>Nog {notShown} transacties tonen</button></div>}
  </div>
}

export interface ResetCategoryScope {
  resetCategoryScope: () => void
  text: string
}

interface TransactionsFilterProps {
  transactionsSettings: TransactionsSettings
  setTransactionsSettings: (transactionsSettings: TransactionsSettings) => void
}

export const TransactionsFilter: React.FC<TransactionsFilterProps> = ({transactionsSettings, setTransactionsSettings}) => {
  // const setCategoryId = (categoryId: number) => {
  //   setTransactionsSettings({...transactionsSettings, categoryId})
  // }

  const setName = (name: string) => {
    setTransactionsSettings({...transactionsSettings, name})
  }

  return <>
    <FormTextInput label="Zoeken" value={transactionsSettings.name} onChange={(e) => setName(e.target.value)} showValidity={false} validationResult={{valid: true}}/>
    {/*<FormCategorySelect selectedItemId={transactionsSettings.categoryId} onChange={setCategoryId} allCategories includeTopCategories/>*/}
  </>
}
